export default function(route, listLabelId, startName, destName, contentLabels, startMarker, endMarker) {
    
    const inlineStyleRegex = /style\s*=\s*\"[^\"]+\"/gi;
    //TODO: if we get into waypoints, will need to specify a name? for each waypoint for aria labels.

    function renderManeuver(maneuver) {
        return `<div class="nav-maneuver-wrapper">
                    <img src="https://maps.gstatic.com/mapfiles/api-3/images/maneuvers_hdpi.png" 
                            height="19" width="19" 
                            class="nav-maneuver nav-maneuver-${maneuver}" 
                            alt="" aria-hidden="true" />
                </div>`;
    }
    function renderStep(maneuver, instructions, distance) {
        const maneuverIndicator = maneuver ? renderManeuver(maneuver) : '';
        const distanceLabel = contentLabels.distancePrefix ? ` <span class='visually-hidden'> ${contentLabels.distancePrefix} </span> ` : '';
        const innerContent = distance ? `<div class="instructions-container">${instructions}</div>
                                        <div class="distance-indicator">
                                            <div class="pseudo" aria-hidden="true"> </div>
                                            <p class="content">${distanceLabel} ${distance}</p>
                                        </div>`: `<div>${instructions}</div>`;
        return `<li class="list-item nav-step">
                    ${maneuverIndicator}
                    <div class="nav-step-content">
                        ${innerContent}
                   </div>
                </li>`;
    }

    function renderLeg(leg, isLast, legLabelId) {
        const endAddress = isLast ? destName : leg.end_address;
        const intermediateSteps = leg.steps.map(step => renderStep(step.maneuver, step.instructions.replace(inlineStyleRegex, ''), step.distance.text)).join('');

        const startInstructions = `<span class="visually-hidden">${contentLabels.startAtLabel}</span> ${startName || leg.start_address}`;
        const endInstructions = `<span class="visually-hidden">${contentLabels.endAtLabel}</span> ${endMarker || ''} ${endAddress}`;

        const startLocationId = `${legLabelId}-start`;
        const endLocationId = `${legLabelId}-end`;
        const durationId = `${legLabelId}-duration`

        return `    <p class="start-instruction" id="${startLocationId}">${startInstructions}</p>
                    <p id="${durationId}">${leg.distance.text} / ${leg.duration.text}</p>
                    <ol aria-labelledby="${legLabelId}" aria-describedby="${durationId}" class="nav-steps">
                        ${intermediateSteps}
                    </ol>
                    <p class="end-instruction" id="${endLocationId}">${endInstructions}</p>`;
    };

    const dirWarnings = route.warnings.map(warning => `<p>${warning}</p>`).join('');
    const dirInstructions =  route.legs.map((leg, i) => renderLeg(leg, i === route.legs.length-1, listLabelId));

    const dirInstructionsHtml = dirInstructions.length > 1 ? 
        `<ol aria-labelledby="${listLabelId}">${dirInstructions.map(instr => '<li>'+instr+'</li>').join('')}</ol>` 
        : dirInstructions[0];

    return `<div class="directions-warnings" id="${listLabelId}-warnings">${dirWarnings}</div>
           ${dirInstructionsHtml}
            <p class="gmap-copyright">${route.copyrights}</p>`;
}